import React from 'react';
import axios from 'axios';
import { Icon, Message, Form, Button, Segment, Modal } from 'semantic-ui-react';
import { PANELCHANGER_BASEURL } from '../../constants/system';
import MfaVerifyForm from './MfaVerifyForm';

/**
 * Login component. Two-step flow: credentials -> optional MFA verify.
 */
export default class Login extends React.Component {

    state = {
        showForgotPassword: false,
        forgotIdentifier: '',
        forgotLoading: false,
        forgotSuccess: false,
        forgotError: null,
        pendingUsername: null,
        pendingPassword: null
    };

    /**
     * Initialize
     */
    componentDidMount() {
        if (!this.props.mfaRequired) {
            var el = document.getElementById('username');
            if (el) el.focus();
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.mfaRequired && prevProps.mfaRequired) {
            this.setState({ pendingUsername: null, pendingPassword: null });
        }
    }

    /**
     * Login (step 1; may lead to MFA step)
     */
    handleLogin() {
        var username = document.getElementById('username').value;
        var password = document.getElementById('password').value;

        if (username !== '' && password !== '')
        {
            this.setState({ pendingUsername: username, pendingPassword: password });
            this.props.login(username, password);
        }
        else
        {
            alert('Név és jelszó megadása kötelező.');
        }
    }

    openForgotPassword = () => this.setState({ showForgotPassword: true, forgotIdentifier: '', forgotSuccess: false, forgotError: null });
    closeForgotPassword = () => this.setState({ showForgotPassword: false, forgotIdentifier: '', forgotSuccess: false, forgotError: null });

    handleForgotPasswordSubmit = () => {
        const identifier = (this.state.forgotIdentifier || '').trim();
        if (!identifier) {
            this.setState({ forgotError: 'Add meg az 5-2-1 azonosítód.' });
            return;
        }
        this.setState({ forgotLoading: true, forgotError: null });
        axios({
            url: PANELCHANGER_BASEURL + '/forgot-password',
            method: 'post',
            data: { identifier },
            timeout: 20000
        })
            .then(() => this.setState({ forgotLoading: false, forgotSuccess: true }))
            .catch((err) => {
                const msg = err.response && err.response.data ? (typeof err.response.data === 'string' ? err.response.data : (err.response.data.message || JSON.stringify(err.response.data))) : err.message;
                this.setState({ forgotLoading: false, forgotError: msg || 'Kérjük, próbáld később.' });
            });
    };

	render() {
		const { mfaRequired, mfaTicket, error, isLoading, login, verifyMfa, cancelMfa } = this.props;
		const { pendingUsername, pendingPassword } = this.state;

		if (mfaRequired && mfaTicket) {
			return (
				<div>
					{error === undefined ? '' : <Message error>{error}</Message>}
					<Segment padded='very' loading={isLoading} className="login-segment">
						<div className="app-logo-block">
							<img alt="" src="/sxtlogo2.png" className="app-logo-img" />
							<span className="app-logo-text">SLR Light</span>
						</div>
						<br />
						<br />
						<MfaVerifyForm
							visible={true}
							ticket={mfaTicket}
							error={null}
							isLoading={isLoading}
							onVerify={verifyMfa}
							onResend={() => {
								if (pendingUsername && pendingPassword) {
									login(pendingUsername, pendingPassword);
								}
							}}
							onBack={cancelMfa}
							embedded
						/>
					</Segment>
					<div className='splashfooter'>
						<center>
							<small style={{ color: '#555' }}>
								Az oldal használatával elfogadod, hogy gépedre sütiket teszünk.
								<br />
								{window.document.title}
								<br />
								&copy; 2019 - 2026
							</small>
						</center>
					</div>
				</div>
			);
		}

		return  <div>
                    { error === undefined ? '' : <Message error>Nem sikerült a bejelentkezés. { error }</Message> }					
                    <Segment padded='very' loading={ isLoading } className="login-segment">
                        <div className="app-logo-block">
							<img alt="" src="/sxtlogo2.png" className="app-logo-img" />
							<span className="app-logo-text">SLR Light</span>
						</div>
                        <br/>
                        <br/>
                        <Form style={{ maxWidth: '300px' }}>
                            <Form.Field>
                                <label>Felhasználó azonosítód</label>
                                <input id='username' type="text" placeholder='5-2-1 azonosítód' />
                            </Form.Field>
                            <Form.Field>
                                <label>Jelszó</label>
                                <input type='password' id='password' placeholder='Jelszó' />
                            </Form.Field>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                                <Button onClick={ () => this.handleLogin() } primary><Icon name='key' /> Belépés</Button>
                                <button
                                    type="button"
                                    className="login-forgot-link"
                                    onClick={() => this.openForgotPassword()}
                                    style={{ fontSize: '0.9rem', color: '#666', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                                >
                                    Elfelejtett jelszó
                                </button>
                            </div>
                        </Form>
                        <Message info>Figyelem! A belépési <b>név ezentúl az 5-2-1 azonosítód</b>, tehát például KISSAZO0. Amennyiben a böngésződ megjegyezte a korábbi nevedet, frissítsd azt. Jelszavad változatlan maradt.</Message>
                    </Segment>

                    <Modal open={this.state.showForgotPassword} onClose={this.closeForgotPassword} size="small">
                        <Modal.Header>Elfelejtett jelszó</Modal.Header>
                        <Modal.Content>
                            {this.state.forgotSuccess ? (
                                <Message success>
                                    Ha ez az azonosító regisztrált nálunk, e-mailt küldtünk a jelszó visszaállítási linkkel. Nézd a postaládádat.
                                    <p style={{ marginTop: '0.5rem', marginBottom: 0 }}>Az új jelszónak meg kell felelnie a jelszókövetelményeknek: legalább 12 karakter, nagybetű, kisbetű, szám és speciális karakter.</p>
                                </Message>
                            ) : (
                                <React.Fragment>
                                    <p style={{ marginBottom: '1rem' }}>Add meg az 5-2-1 azonosítódat, és ha regisztrált, elküldjük a jelszó visszaállítási linket.</p>
                                    {this.state.forgotError && <Message error>{this.state.forgotError}</Message>}
                                    <Form>
                                        <Form.Field>
                                            <label>5-2-1 azonosító</label>
                                            <input
                                                type="text"
                                                placeholder="pl. KISSAZO0"
                                                value={this.state.forgotIdentifier}
                                                onChange={(e) => this.setState({ forgotIdentifier: e.target.value })}
                                            />
                                        </Form.Field>
                                    </Form>
                                </React.Fragment>
                            )}
                        </Modal.Content>
                        <Modal.Actions>
                            {this.state.forgotSuccess ? (
                                <Button primary onClick={this.closeForgotPassword}>Rendben</Button>
                            ) : (
                                <React.Fragment>
                                    <Button onClick={this.closeForgotPassword}>Mégse</Button>
                                    <Button primary loading={this.state.forgotLoading} onClick={this.handleForgotPasswordSubmit}>
                                        Küldés
                                    </Button>
                                </React.Fragment>
                            )}
                        </Modal.Actions>
                    </Modal>
                    <div className='splashfooter'>
                        <center>
                            <small style={{ 'color': '#555' }}>
                                Az oldal használatával elfogadod, hogy gépedre sütiket teszünk.
                                <br/>
                                {window.document.title}
                                <br/>
                                &copy; 2019 - 2026
                            </small>
                        </center>
                    </div>
                </div>
	}
}